import { readStorageSafe } from './shared/readStorageSafe';
import { createStorageHooks } from './shared/storage';

const { useStorageValue: useLocalStorageValue, useStorageValueAsync: useLocalStorageValueAsync } = createStorageHooks(
	readStorageSafe((window) => window.localStorage),
);

export { useLocalStorageValue, useLocalStorageValueAsync };
